import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpgradeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.6 20.5",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .upgrade-icon-cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n\n      .upgrade-icon-cls-2 {\n        fill: currentColor;\n      }\n    " }) }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_1",
		children: [/* @__PURE__ */ _jsx("path", {
			className: "upgrade-icon-cls-1",
			d: "M5.8,19.5h6"
		}), /* @__PURE__ */ _jsx("path", {
			className: "upgrade-icon-cls-2",
			d: "M8.8,1l.8-.6c-.2-.2-.5-.4-.8-.4s-.6.1-.8.4l.8.6ZM16.6,10.8v1c.4,0,.7-.2.9-.6.2-.3.1-.8-.1-1.1l-.8.6ZM1,10.8l-.8-.6c-.2.3-.3.7-.1,1.1.2.3.5.6.9.6v-1ZM5.8,10.8h1c0-.6-.4-1-1-1v1ZM5.8,16.5h-1c0,.6.4,1,1,1v-1ZM11.8,16.5v1c.6,0,1-.4,1-1h-1ZM11.8,10.8v-1c-.6,0-1,.4-1,1h1ZM8,1.6l7.8,9.8,1.6-1.2L9.6.4l-1.6,1.2ZM1.8,11.4L9.6,1.6l-1.6-1.2L.2,10.1l1.6,1.2ZM5.8,9.8H1v2h4.8v-2ZM6.8,16.5v-5.7h-2v5.7h2ZM11.8,15.5h-6v2h6v-2ZM10.8,10.8v5.7h2v-5.7h-2ZM16.6,9.8h-4.8v2h4.8v-2Z"
		})]
	}) })]
});
export default SvgUpgradeIcon;
